export default "__VITE_ASSET__b6a9cd4b__"